import React from "react";
import { Link } from "react-router-dom";

const Error404 = () => {
  return (
    <>
      {/* Main Wrapper */}
      <div className="error-page">
        <div className="main-wrapper">
          <div className="error-box">
            <h1>404</h1>
            <h3>
              <i className="fa-solid fa-triangle-exclamation" /> أُووبس! الصفحة
              غير موجودة!
            </h3>
            <p>الصفحة المطلوبة لم يتم العثور عليها.</p>
            <Link to="/ft-intro" className="btn btn-custom">
              الصفحة الرئيسية
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Error404;
